exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-logo.footer {\n  text-align: center; }\n\n.report-logo img {\n  height: 90px;\n  width: auto; }\n\n.report-logo.vintron-logo img {\n  height: 50px; }\n", ""]);

// exports
